export const getBlobData = state => state.blobs.blob;
export const blobIsFetching = state => state.blobs.loading;